import React, { Component } from "react";
import { connect } from "react-redux";
import update from "immutability-helper";
import { changeLocInfoAction, changeDistAction, setModeleTableAction, setUserLicenseAction, changeIsStartAction, changeIsBusySAction, changeIsBusyCAction, changedataDownloadAction, setGMUrlAction, changeInExeWaitngAction, changeInPredictAction } from "../redux/app/actions";
import { finBoringLoadAction, changeAllDsAction, changeRegNumAction, changeNewDsAction, changeCrossValidAction } from "../redux/boring/actions";
import { changeIdAction } from "../redux/user/actions";
import { changeBoringID1Action, changeBoringID2Action } from "../redux/editer/actions";
import { delAllDsAction as delAllDsRsltPlAction, resetCellAction, clickCellAction } from "../redux/rsltPl/actions";
import { delAllDsAction as delAllDsRsltCsAction } from "../redux/csDsp/actions";
import { finParamLoadAction, changeEnvAction, changeRegionAction } from "../redux/param/actions";
import { openEditerAction, changeBmapAction, showRegionModelWindowAction, showDetailEditerWindowAction } from "../redux/ui/actions";
import {
  changeAnalyRadiusAction,
  changeAnalyBHHeightAction,
  changeAnalyPumpAction,
  changeAnalyWLAction,
  changeMeshRadiusAction,
  changeMeshVertexAction,
  changeMeshSplitAction,
  changeMeshBiasAction,
  changeWsArAction,
  changeInitNumAction,
  changeDsAction,
  changeBorDsAction,
  changeAnalyTargetAction,
  changePompAmountAction,
  changeWLDAmountAction,
  changeModelKindAction,
  changeMeshZSplitAction,
  changeScreenZSplitAction,
  changeMapMeshLayAction,
  changeEquPermCheckAction,
  changeProbThresholdAction,
  addWellsTrAction,
  changeAnalysisTypeAction,
  changeMaxScrNumAction,
} from "../redux/boring/actions";
import { initDsAction } from "../redux/geo/actions";
import { updateLakeTrAction } from "../redux/well/actions";
import Header from "./Header";
import TopBtn from "./TopBtn";
import Editer from "./Editer";
import EstBoring from "./EstBoring";
import pako from "pako";
import { changeDataDownloadReduce } from "../redux/app/reducer";

const mapStateToProps = state => {
  return {
    editerMode: state.appReducer.editerMode,
    inPredict: state.appReducer.inPredict,
    rsltTab: state.appReducer.rsltTab,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    newDs: state.boringReducer.newDs,
    finBoringLoad: state.boringReducer.finBoringLoad,
    boringDs: state.boringReducer.dataset,
    showChk: state.boringReducer.showChk,
    exVarCat: state.boringReducer.exVarCat,
    exVarName: state.boringReducer.exVarName,
    rsltPlDs: state.rsltPlReducer.ds,
    rsltPlCat: state.rsltPlReducer.cat,
    rsltPlExVarCat: state.rsltPlReducer.exVarCat,
    rsltPlExVarName: state.rsltPlReducer.exVarName,
    finParamLoad: state.paramReducer.finParamLoad,
    swCat: state.uiReducer.swCat,
    editerSw: state.uiReducer.editerSw,
    topBtnSwCat: state.uiReducer.topBtnSwCat,
    meshRadius: state.boringReducer.meshRadius,
    meshVertex: state.boringReducer.meshVertex,
    meshSplit: state.boringReducer.meshSplit,
    meshZSplit: state.boringReducer.meshZSplit,
    meshBias: state.boringReducer.meshBias,
    modelKind: state.boringReducer.modelKind,
    crossValid: state.boringReducer.crossValid,
    regionModelWindowVisible: state.uiReducer.regionModelWindowVisible,
    wellsTrData: state.boringReducer.wellsTrData,
    userLicense: state.appReducer.userLicense,
    moduleTable: state.appReducer.moduleTable,
    lakeTrData: state.wellReducer.lakeTrData,

    isLogin: state.userReducer.isLogin,
    id: state.userReducer.id,
    isStart: state.appReducer.isStart,
    isBusyS: state.appReducer.isBusyS,
    isBusyC: state.appReducer.isBusyC,
    inExeWating: state.appReducer.inExeWating,
    waitingTime: state.appReducer.waitingTime,
    waterShedSelectable: state.uiReducer.waterShedSelectable,
  };
};

//TODO:ローカルのボーリングデータを使うかサーバから読み出すかの切り替えフラグ
//ローカル開発時はfalseとすることで、サーバからデータを読み込まないようにする
const useServerData = true;

class App extends Component {
  constructor(props) {
    super(props);
    this.clickMap = this.clickMap.bind(this);
    this.RightclickMap = this.RightclickMap.bind(this);
    this.cancelExe = this.cancelExe.bind(this);
    this.loadingCheckIntervalId = null;
    this.props.dispatch(changeBmapAction("std"));
    this.props.dispatch(changeIsStartAction(false));

    this.state = {
      loadingMessage: "地図読み込み中...",
      loadingTime: 0,
    };
    //GM-WELLパラメータ初期値設定
    if (useServerData) {
      this.props.dispatch(delAllDsRsltPlAction());
      this.props.dispatch(delAllDsRsltCsAction());
    }
  }

  /*
   * GM-WELL設定ファイル読み込み
   * @since ando 2023-10-23
   */
  loadConfig() {
    let csv = new XMLHttpRequest();

    // CSVファイルへのパス
    csv.open("GET", "./conf/well_init.csv", false);

    // csvファイル読み込み失敗時のエラー対応
    try {
      csv.send(null);
    } catch (err) {
      console.log(err);
      this.props.dispatch(changeMeshRadiusAction(500));
      this.props.dispatch(changeMeshVertexAction(18));
      this.props.dispatch(changeMeshSplitAction(5));
      this.props.dispatch(changeMeshZSplitAction(20));
      this.props.dispatch(changeMeshBiasAction(5));
      this.props.dispatch(changeAnalyRadiusAction(0.1));
      this.props.dispatch(changeAnalyBHHeightAction(150));
      this.props.dispatch(changeAnalyPumpAction(150));
      this.props.dispatch(changeAnalyWLAction(55));
      this.props.dispatch(changeAnalyTargetAction(1));
      this.props.dispatch(changePompAmountAction(5));
      this.props.dispatch(changeWLDAmountAction(5));
      this.props.dispatch(changeModelKindAction(1));
      this.props.dispatch(changeScreenZSplitAction(1));
      this.props.dispatch(changeMapMeshLayAction(3));
      this.props.dispatch(changeEquPermCheckAction(0));
      this.props.dispatch(changeProbThresholdAction(30));
      this.props.dispatch(changeCrossValidAction(0));
      this.props.dispatch(changeWsArAction(5));
      this.props.dispatch(setGMUrlAction("https://geomodeler.gmlabo.jp/main.html"));
    }

    // 配列を定義
    let csvArray = [];

    // 改行ごとに配列化
    let lines = csv.responseText.split(/\r\n|\n/);

    // 1行ごとに処理
    for (let i = 0; i < lines.length; ++i) {
      let cells = lines[i].split(",");
      csvArray.push(cells[0]);
    }
    // コンソールに配列を出力
    this.props.dispatch(changeMeshRadiusAction(csvArray[0]));
    this.props.dispatch(changeMeshVertexAction(csvArray[1]));
    this.props.dispatch(changeMeshSplitAction(csvArray[2]));
    this.props.dispatch(changeMeshZSplitAction(csvArray[3]));
    this.props.dispatch(changeMeshBiasAction(csvArray[4]));
    this.props.dispatch(changeAnalyRadiusAction(csvArray[5]));
    this.props.dispatch(changeAnalyBHHeightAction(csvArray[6]));
    this.props.dispatch(changeAnalyPumpAction(csvArray[7]));
    this.props.dispatch(changeAnalyWLAction(csvArray[8]));
    this.props.dispatch(changeAnalyTargetAction(csvArray[9]));
    this.props.dispatch(changePompAmountAction(csvArray[10]));
    this.props.dispatch(changeWLDAmountAction(csvArray[11]));
    this.props.dispatch(changeModelKindAction(csvArray[12]));
    this.props.dispatch(changeScreenZSplitAction(csvArray[13]));
    this.props.dispatch(changeMapMeshLayAction(csvArray[14]));
    this.props.dispatch(changeEquPermCheckAction(csvArray[15]));
    this.props.dispatch(changeProbThresholdAction(csvArray[16]));
    this.props.dispatch(changeCrossValidAction(csvArray[17]));
    this.props.dispatch(changeWsArAction(csvArray[18]));
    this.props.dispatch(setGMUrlAction(csvArray[19]));

    //this.setState({
    //    loadingTime: this.state.loadingTime + 5
    //});
  }

  /*
   * 機能制御ファイル読み込み
   * @since ando 2024-03-08
   */
  loadModuleControl() {
    fetch("./conf/module_control.csv")
      .then(response => response.text())
      .then(csvText => {
        let csvArray = [];
        let lines = csvText.split(/\r\n|\n/);
        // 1行ごとに処理
        for (let i = 1; i < lines.length; ++i) {
          let cells = lines[i].split(",");
          csvArray[cells[0]] = cells;
        }

        this.props.dispatch(setModeleTableAction(csvArray));
        //this.setState({
        //    loadingTime: this.state.loadingTime + 5
        //});
      })
      .catch(error => console.log(error));
  }

  /*
   * 計測データファイル読み込み
   * @since ando 2025-11-17
   */
  async loadMeaDataFile() {
    let points = [];

    fetch("./conf/mea.csv")
      .then(response => response.text())
      .then(csvText => {
        let csvArray = [];
        let lines = csvText.split(/\r\n|\n/);
        // 1行ごとに処理
        for (let i = 1; i < lines.length - 1; ++i) {
          let cells = lines[i].split(",");
          points.push({
            id: cells[0],
            lat: parseFloat(cells[1]),
            lon: parseFloat(cells[2]),
          });
        }
        return window.setPompArr(points);
      })
      .catch(error => console.log(error));
  }

  /*
   * パラメータ読み込み
   * @since hara 2021-06-30
   */
  loadParam() {
    if (!this.props.finParamLoad) {
      if (useServerData) {
        //                this.props.dispatch(changeEnvAction('環境データ'));
        //                this.props.dispatch(changeRegionAction('地域データ'));
      }

      this.props.dispatch(finParamLoadAction(true));
    }
  }

  /*
   * ボーリングデータ一つのロード%を計算する
   * @since ando 2024-03-15
   */
  distributeValue(total, count) {
    const quotient = Math.floor(total / count);
    const remainder = total % count;
    const result = new Array(count).fill(quotient);

    for (let i = 0; i < remainder; i++) {
      result[i]++;
    }

    return result;
  }

  async loadBoring() {
    if (!this.props.finBoringLoad) {
      let regNum = null;
      if (useServerData) {
        //サーバからボーリングデータを読み込む場合
        const origin = window.location.origin;
        const search = window.location.search;
        let totalReceivedBytes = 0; // 受信した合計バイト数を保持する変数
        let receivedData = []; // 受信したデータを保持する配列

        fetch(`${origin}/api/boring/${search}`)
          .then(res => {
            const contentLength = parseInt(res.headers.get("x-content-length")); // Content-Lengthヘッダーの値を取得

            /*
                                                const reader = res.body.getReader(); // ReadableStreamからリーダーを作成

                                                return new Promise((resolve, reject) => {
                                                    const processResult = ({ done, value }) => {
                                                        if (done) {
                                                            console.log('Total bytes received:', totalReceivedBytes);
                                                            resolve(receivedData); // 受信したデータを解決する
                                                            return;
                                                        }
                                                        totalReceivedBytes += value.length; // 受信したバイト数を合計に加算
                                                        if (totalReceivedBytes > contentLength) {
                                                            this.setState({
                                                                loadingTime: 90
                                                            });
                                                        } else {
                                                            this.setState({
                                                                loadingTime: Math.floor((totalReceivedBytes / contentLength) * 90)
                                                            });
                                                        }
                                                        receivedData.push(value); // 受信したデータを配列に追加
                                                        reader.read().then(processResult); // 次のチャンクを読み込む
                                                    };

                                                    reader.read().then(processResult);
                        */

            const reader = res.body.getReader(); // ReadableStreamからリーダーを作成

            // 解凍処理
            const decoder = new TextDecoder();
            const inflater = new pako.Inflate({ to: "string" });

            return new Promise((resolve, reject) => {
              const processResult = ({ done, value }) => {
                if (done) {
                  // 全てのデータが解凍された後に、受信データをJSON形式に変換して解析する
                  const parsedData = JSON.parse(inflater.result); // JSON文字列を解析してJavaScriptオブジェクトに変換する
                  resolve(parsedData); // 解析されたデータを解決する
                  return;
                }

                // データを解凍
                inflater.push(value, false);
                totalReceivedBytes += value.length;

                // 受信したデータの進捗を計算
                const progress = Math.round((totalReceivedBytes / contentLength) * 90);
                console.log(`Received ${totalReceivedBytes} bytes (${progress}% completed)`);
                if (totalReceivedBytes > contentLength) {
                  this.setState({
                    loadingTime: 90,
                  });
                  this.props.dispatch(changedataDownloadAction(90));
                } else {
                  this.setState({
                    loadingTime: progress,
                  });
                  this.props.dispatch(changedataDownloadAction(progress));
                }

                reader.read().then(processResult); // 次のチャンクを読み込む
              };

              reader.read().then(processResult);
            });
          })
          /*
                    .then(data => {
                        // 受信したデータを結合してバッファを作成
                        const buffer = new Uint8Array(totalReceivedBytes);
                        let offset = 0;
                        for (const chunk of data) {
                            buffer.set(chunk, offset);
                            offset += chunk.length;
                        }
                        // バッファを文字列に変換してJSONにパースする
                        const jsonString = new TextDecoder().decode(buffer);
                        console.log("parse")
                        return JSON.parse(jsonString);
                    })
                    */
          .then(res => {
            // JSONデータを処理する部分
            const dsLeng = res.length;
            const loadBor = this.distributeValue(10, dsLeng);
            const promises = res.map((el, index) => {
              return new Promise(resolve => {
                setTimeout(() => {
                  window.createBoringLay(el.data, el.color, el.ID, el.vis, dsLeng - el.zIndex);
                  if (window.getUserLicense() == 4) {
                    window.groupByData(el.data);
                  }
                  this.setState({
                    loadingTime: this.state.loadingTime + loadBor[index],
                  });
                  this.props.dispatch(changedataDownloadAction(this.state.loadingTime + loadBor[index]));
                  resolve();
                }, 200);
              });
            });
            return Promise.all(promises).then(() => res);
          })
          .then(res => {
            // すべてのデータの処理が完了した後に実行する処理
            window.createScoreContour(false);
            const regNum = res.length;
            this.props.dispatch(changeAllDsAction(res));
            this.props.dispatch(changeRegNumAction(regNum));
            this.props.dispatch(changeInitNumAction(regNum));
            this.setState({
              loadingTime: 100,
            });
            this.props.dispatch(changedataDownloadAction(100));
            this.props.dispatch(finBoringLoadAction(true));
            console.log(totalReceivedBytes);
          })
          .catch(error => {
            // エラーハンドリング
            console.error("An error occurred:", error);
          });
      } else {
        //ローカルデータをボーリングデータとして読み込む場合
        window.initMap();
        const dsLeng = this.props.boringDs.length;
        this.props.boringDs.forEach(el => {
          window.createBoringLay(el.data, el.color, el.ID, el.vis, dsLeng - el.zIndex);
        });

        regNum = this.props.boringDs.length;
        this.props.dispatch(changeRegNumAction(regNum));

        //boringDsをNewDsにコピーする（Editerで使用）
        //this.props.dispatch(changeNewDsAction(JSON.parse(JSON.stringify(this.props.boringDs))));
        this.props.dispatch(changeNewDsAction(this.props.boringDs));
      }
    }
  }

  async loadStart() {
    const origin = window.location.origin;
    const search = window.location.search;
    fetch(`${origin}/api/start/${search}`)
      .then(res => res.json())
      .then(res => {
        if (res.succ) {
          if (res.type == null) {
            alert("認証エラーが発生しました。お手数をおかけいたしますが再度ログインしてください。");
            window.location.href = "https://activation.gmlabo.jp";
          } else {
            this.props.dispatch(changeIdAction(res.name));
            this.props.dispatch(setUserLicenseAction(res.type));
            window.setUserLicense(res.type);
            if (res.type == 2) {
              this.props.dispatch(changeAnalysisTypeAction(6));
              this.props.dispatch(changeMaxScrNumAction(0));
            }
          }
        } else {
          alert("認証エラーが発生しました。認証状態が不正です。");
          window.location.href = "https://activation.gmlabo.jp";
        }
      })
      .catch(err => console.log(err));
  }

  async loadGeoDs() {
    const origin = window.location.origin;
    const search = window.location.search;
    fetch(`${origin}/api/geoInfo/datasets/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(res => {
        res.forEach(el => {
          el.geo.forEach(g => {
            g.screen = g.screen == "0" ? false : true;
            g.group = [g.group];
          });
        });
        this.props.dispatch(initDsAction(res));
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
      });
  }
  async componentDidMount() {
    await window.checkSpeed("通信速度が低速です。恐れ入りますが、アプリケーションの起動まで時間を要する場合がございます。", 3000);
    this.loadStart()
      .then(() => {
        return this.loadModuleControl();
      })
      .then(
        () =>
          new Promise(resolve => {
            // initMapなどの非同期処理が完了するまで待つ
            window.initMap();
            this.setState({
              loadingTime: this.state.loadingTime + 5,
            });
            resolve(); // 非同期処理が完了したらresolveする
          })
      )
      .then(() => this.loadConfig())
      .then(() => this.loadBoring())
      .then(() => this.loadGeoDs())
      .then(() => this.loadMeaDataFile())
      .then(
        () =>
          new Promise(resolve => {
            window.initWaterData(window.location.origin);
            resolve();
          })
      )
      // .then(() => this.setState({
      //    loadingTime: this.state.loadingTime + 25
      //}))
      .catch(error => {
        // エラーハンドリング
        console.error("An error occurred:", error);
      });

    this.loadingCheckIntervalId = setInterval(() => this.chkLoading(), 500);
    this.downloadIntervalId = setInterval(() => this.chkDataDownload(), 500);

    setInterval(() => this.getServerInfo(), 3000);

    setInterval(() => this.getClientInfo(), 3000);
  }
  chkLoading() {
    //描画が終了したか確認する。
    if (this.state.loadingTime >= 5) {
      setInterval(() => this.props.dispatch(changeIsStartAction(true)), clearInterval(this.loadingCheckIntervalId), 500);
    }
  }

  chkDataDownload() {
    //データダウンロードが終了したか確認する。
    if (this.state.loadingTime >= 100) {
      setInterval(() => clearInterval(this.downloadIntervalId), 500);
    }
  }

  async getServerInfo() {
    const origin = window.location.origin;
    try {
      const response = await fetch(`${origin}/api/serverInfo`, {
        method: "POST",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("server_memory:", data);
      //console.log(data.memoryInfo["usagePercentage"])

      //サーバー側のパフォーマンス測定
      if (parseFloat(data.memoryInfo["usagePercentage"]) <= window.getMemoryST()) {
        this.props.dispatch(changeIsBusySAction(false));
      } else {
        this.props.dispatch(changeIsBusySAction(true));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async getClientInfo() {
    try {
      //クライアント側のパフォーマンス測定
      const memoryInfo = window.performance.memory;
      if (memoryInfo != undefined) {
        const memoryUsagePercentage = Math.round((memoryInfo.totalJSHeapSize / memoryInfo.jsHeapSizeLimit) * 10000) / 100; // 小数点以下2桁に丸める
        if (memoryUsagePercentage <= window.getMemoryCT()) {
          this.props.dispatch(changeIsBusyCAction(false));
        } else {
          this.props.dispatch(changeIsBusyCAction(true));
        }
        console.log("client_memory:", memoryUsagePercentage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  /*
   * マップクリック
   * @since hara 2020-09-09
   */
  clickMap() {
    if (this.props.editerMode === 0) {
      let boringID1 = null;
      let boringID2 = null;

      /*
       * エディタ表示
       */
      const id = window.getBoringID();

      if (id !== null) {
        if (id !== undefined) {
          const idD = id.split("_");
          boringID1 = idD[0];
          boringID2 = idD[1];
          this.props.dispatch(changeBoringID1Action(boringID1));
          this.props.dispatch(changeBoringID2Action(boringID2));
          if (this.props.newDs != undefined && this.props.boringID1 != undefined && this.props.newDs[this.props.boringID1].data[this.props.boringID2] != undefined) {
            this.props.dispatch(
              changeBorDsAction({
                boringID1: this.props.boringID1,
                data: this.props.newDs[this.props.boringID1].data[this.props.boringID2],
              })
            );

            this.props.dispatch(openEditerAction(id));
            this.props.dispatch(showDetailEditerWindowAction(false));
          } else {
            this.props.dispatch(openEditerAction(id));
            this.props.dispatch(showDetailEditerWindowAction(false));
            //boringDsをNewDsにコピーする（Editerで使用）
            //this.props.dispatch(changeNewDsAction(JSON.parse(JSON.stringify(this.props.boringDs))));
            this.props.dispatch(changeNewDsAction(this.props.boringDs));
          }
        }
      }

      /*
       * トップボタン
       */
      switch (this.props.topBtnSwCat) {
        case "locInfo": //地点情報の場合
          this.props.dispatch(changeLocInfoAction(window.getLocInfoCoord()));
          break;
        case "dist": //距離計測の場合
          const dist = window.getDist();
          if (dist !== null) this.props.dispatch(changeDistAction(dist));
          break;
        case "bColor": //ボーリングカラーの場合
          if (boringID1 !== null && boringID2 !== null) {
            //説明変数距離表示******ボーリングカラーが複数選択肢になった場合ifで囲む
            const boring = this.props.boringDs[boringID1].data[boringID2];
            const env = boring.env[this.props.exVarCat][this.props.exVarName];
            window.createBoringDist([env.lon, env.lat], env.dist);
          } else {
            window.delBoringDist();
          }
          break;
      }

      /*
       * 予測表示（平面）セル
       */
      if (this.props.swCat === "rslt" && this.props.rsltTab === "pl") {
        const cell = window.getRsltPlCellInfo();
        if (cell !== null) {
          const elem = this.props.rsltPlDs[cell.dsID].elem[cell.elemID];
          this.props.dispatch(clickCellAction(cell.dsID, cell.elemID, elem.geoID, elem.prob));

          //説明変数距離表示
          if (this.props.rsltPlCat === "dist") {
            const env = elem.env[this.props.rsltPlExVarCat][this.props.rsltPlExVarName];
            window.createRsltPlDist([env.lon, env.lat], env.dist);
          }
        } else {
          this.props.dispatch(resetCellAction());
        }
      }
    }
    if (this.props.regionModelWindowVisible) {
      let wellsData = window.getWellsPoint();
      if (this.props.wellsTrData.length + 1 == window.getWellsPoints().length) {
        //EP確認用
        //console.log('------------配列wellsData出力------------')
        //console.log('緯度：' + wellsData[1])
        //console.log('経度：' + wellsData[0])
        this.props.dispatch(addWellsTrAction(this.props.wellsTrData.length + 1, window.formatNumber(wellsData[1]), window.formatNumber(wellsData[0]), "type1", 0, []));
        //}else{
      }
    }

    //クリックされた流域界に応じて、流域界内の湖沼データテーブルを更新する

    //lakeTrDataとwsLakeMapを突き合わせてlakeTrDataを更新する
    if (this.props.waterShedSelectable) {
      this.props.dispatch(updateLakeTrAction(window.syncLakeTrData(this.props.lakeTrData, window.getWsLakes())));
    }
  }

  RightclickMap = () => {
    if (this.props.regionModelWindowVisible) {
      let wellsData = window.getWellsPoint();
      if (this.props.wellsTrData.length + 1 == window.getWellsPoints().length) {
        this.props.dispatch(addWellsTrAction(this.props.wellsTrData.length + 1, window.formatNumber(wellsData[1]), window.formatNumber(wellsData[0]), "type1", 0, []));
      }
      //}else{

      //}
    }
  };

  async cancelExe() {
    const origin = window.location.origin;
    const search = window.location.search;
    try {
      const res = await fetch(`${origin}/api/0/cancelExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "cancelExe",
        }),
      });
      const json = await res.json();
      console.log("res", json);
      this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      this.props.dispatch(changeInPredictAction(false));
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      this.props.dispatch(changeInPredictAction(false));
      return false; // エラー時も止める
    }
  }

  render() {
    return (
      <div className="l-allHW">
        <div id="map" className="Map" onClick={this.clickMap} onContextMenu={this.RightclickMap}></div>
        {this.props.isStart && (
          <React.Fragment>
            <Header />
            <TopBtn />
          </React.Fragment>
        )}
        {this.props.editerSw ? <Editer /> : null}
        <div className={this.props.inPredict ? "LoaderWrap l-center" : null}>
          <div className={this.props.inPredict ? "loader" : null}></div>
        </div>
        {!this.props.isStart && (
          <div className={this.props.isStart ? null : "LoaderWrap l-center"}>
            <div className="loading-start ">
              {this.state.loadingMessage}
              <br />
            </div>
            <div className="loader2"></div>
          </div>
        )}
        {this.props.isBusyS && !this.props.inPredict && (
          <div className={this.props.isBusyS ? "LoaderWrap2 l-center" : null}>
            <div className="loading-start " style={{ color: "white" }}>
              ただいまサーバーが混雑しております。
              <br />
              恐れ入りますが、暫くお待ちください。
            </div>
            <div className="loader2"></div>
          </div>
        )}
        {this.props.isBusyC && !this.props.inPredict && (
          <div className={this.props.isBusyC ? "LoaderWrap2 l-center" : null}>
            <div className="loading-start " style={{ color: "white" }}>
              ブラウザのメモリが{window.getMemoryCT()}％を超えました。
              <br />
              メモリを解放中です。
              <br />
            </div>
            <div className="loader2"></div>
          </div>
        )}
        {this.props.inExeWating && (
          <div className="LoaderWrap4 l-center">
            <div className="loading-start" style={{ color: "white", textAlign: "center" }}>
              ただいまサーバーが混雑しております。
              <br />
              恐れ入りますが、暫くお待ちください。
              <br />
              目安待ち時間：{this.props.waitingTime}秒
              <br />
              <br />
              <button className="cBtnL " onClick={this.cancelExe}>
                実行キャンセル
              </button>
            </div>
          </div>
        )}

        <div id="zoom" className="zoom"></div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(App);
